function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * dd-resizable-handle.ts 10.3.1
 * Copyright (c) 2021-2022 Alain Dumesny - see GridStack root license
 */
import { isTouch, pointerdown, touchend, touchmove, touchstart } from './dd-touch';
var DDResizableHandle = /*#__PURE__*/function () {
  function DDResizableHandle(host, dir, option) {
    _classCallCheck(this, DDResizableHandle);
    this.host = host;
    this.dir = dir;
    this.option = option;
    /** @internal true after we've moved enough pixels to start a resize */
    this.moving = false;
    // create var event binding so we can easily remove and still look like TS methods (unlike anonymous functions)
    this._mouseDown = this._mouseDown.bind(this);
    this._mouseMove = this._mouseMove.bind(this);
    this._mouseUp = this._mouseUp.bind(this);
    this._keyEvent = this._keyEvent.bind(this);
    this._init();
  }
  /** @internal */
  return _createClass(DDResizableHandle, [{
    key: "_init",
    value: function _init() {
      var el = this.el = document.createElement('div');
      el.classList.add('ui-resizable-handle');
      el.classList.add("".concat(DDResizableHandle.prefix).concat(this.dir));
      el.style.zIndex = '100';
      el.style.userSelect = 'none';
      this.host.appendChild(this.el);
      this.el.addEventListener('mousedown', this._mouseDown);
      if (isTouch) {
        this.el.addEventListener('touchstart', touchstart);
        this.el.addEventListener('pointerdown', pointerdown);
        // this.el.style.touchAction = 'none'; // not needed unlike pointerdown doc comment
      }
      return this;
    }
    /** call this when resize handle needs to be removed and cleaned up */
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.moving) this._mouseUp(this.mouseDownEvent);
      this.el.removeEventListener('mousedown', this._mouseDown);
      if (isTouch) {
        this.el.removeEventListener('touchstart', touchstart);
        this.el.removeEventListener('pointerdown', pointerdown);
      }
      this.host.removeChild(this.el);
      delete this.el;
      delete this.host;
      return this;
    }
    /** @internal called on mouse down on us: capture move on the entire document (mouse might not stay on us) until we release the mouse */
  }, {
    key: "_mouseDown",
    value: function _mouseDown(e) {
      this.mouseDownEvent = e;
      document.addEventListener('mousemove', this._mouseMove, {
        capture: true,
        passive: true
      }); // capture, not bubble
      document.addEventListener('mouseup', this._mouseUp, true);
      if (isTouch) {
        this.el.addEventListener('touchmove', touchmove);
        this.el.addEventListener('touchend', touchend);
      }
      e.stopPropagation();
      e.preventDefault();
    }
    /** @internal */
  }, {
    key: "_mouseMove",
    value: function _mouseMove(e) {
      var s = this.mouseDownEvent;
      if (this.moving) {
        this._triggerEvent('move', e);
      } else if (Math.abs(e.x - s.x) + Math.abs(e.y - s.y) > 2) {
        // don't start unless we've moved at least 3 pixels
        this.moving = true;
        this._triggerEvent('start', this.mouseDownEvent);
        this._triggerEvent('move', e);
        // now track keyboard events to cancel
        document.addEventListener('keydown', this._keyEvent);
      }
      e.stopPropagation();
      // e.preventDefault(); passive = true
    }
    /** @internal */
  }, {
    key: "_mouseUp",
    value: function _mouseUp(e) {
      if (this.moving) {
        this._triggerEvent('stop', e);
        document.removeEventListener('keydown', this._keyEvent);
      }
      document.removeEventListener('mousemove', this._mouseMove, true);
      document.removeEventListener('mouseup', this._mouseUp, true);
      if (isTouch) {
        this.el.removeEventListener('touchmove', touchmove);
        this.el.removeEventListener('touchend', touchend);
      }
      delete this.moving;
      delete this.mouseDownEvent;
      e.stopPropagation();
      e.preventDefault();
    }
    /** @internal call when keys are being pressed - use Esc to cancel */
  }, {
    key: "_keyEvent",
    value: function _keyEvent(e) {
      if (e.key === 'Escape') {
        var _this$host$gridstackN;
        (_this$host$gridstackN = this.host.gridstackNode) === null || _this$host$gridstackN === void 0 || (_this$host$gridstackN = _this$host$gridstackN.grid) === null || _this$host$gridstackN === void 0 || _this$host$gridstackN.engine.restoreInitial();
        this._mouseUp(this.mouseDownEvent);
      }
    }
    /** @internal */
  }, {
    key: "_triggerEvent",
    value: function _triggerEvent(name, event) {
      if (this.option[name]) this.option[name](event);
      return this;
    }
  }]);
}();
/** @internal */
DDResizableHandle.prefix = 'ui-resizable-';
export { DDResizableHandle };